<template>
  <div>
    <div>
      <base-title
        :title="StringLanguage.imagesStore"
        :subtitle="StringLanguage.configurations"
        :link="'configuracoes'"
      />
      <!-- Logotipo -->
      <base-box class="d-flex justify-between mb_20">
        <div class="w-100">
          <img
            v-if="isMobile && images.logo"
            :src="getPreviewUrl(images.logo)"
            class="w-50 mb_25 rounded d-flex"
          />
          <input
            type="file"
            id="logo"
            name="logo"
            class="hidden"
            data-upload="{'max_height':'400','extension':'png, gif'}"
          />
          <base-label :text="StringLanguage.logo" />
          <p class="image-limit">{{ StringLanguage.noLimitsToImage }}.</p>

          <div id="btn_logo" class="mt_20 d-flex">
            <upload-image
              :environment="environment"
              :maxWidth="512"
              :maxHeight="512"
              @setImage="setImageLogo"
            >
              <base-button :text="setLabel('logo')" design="four" />
            </upload-image>
            <base-button
              :class="{ hidden: !images.logo }"
              class="ml_15"
              :text="StringLanguage.delete"
              design="four"
              @click="images.logo = ''"
            />
            <input type="hidden" v-model="images.logo" value="" />

            <!-- <div id="btn_logo_control" class="ml_15" :class="{'hidden' : !images.logo }">
                    <base-button :text="StringLanguage.view" design="four"  id="btn_logo_view" @click="() => openPreview(images.logo)" class="mr_15"/>
                    <base-button :text="StringLanguage.delete" design="four"  @click="images.logo = ''"/>
                    </div> -->
          </div>
        </div>
        <div>
          <img
            class="rounded"
            v-if="!isMobile && images.logo"
            :src="getPreviewUrl(images.logo)"
            style="height: 92px; width: auto"
          />
        </div>
      </base-box>
      <!-- fim logotipo -->

      <!-- Capa -->
      <base-box class="d-flex justify-between align-center mb_20">
        <div>
          <img
            v-if="isMobile && images.background_mobile"
            :src="getPreviewUrl(images.background_mobile)"
            class="w-100 mb_25"
          />
          <input
            type="file"
            id="background"
            name="background"
            class="form-control hidden"
            data-upload="{'max_height':'1080','max_width':'1920','extension':'jpg, jpeg, png, gif'}"
          />
          <base-label :text="StringLanguage.cover" />
          <p class="image-limit">{{ StringLanguage.minResolutionToCover }}.</p>

          <div id="btn_background" class="mt_20 d-flex">
            <!-- Se for suporte -->
            <upload-image
              :environment="environment"
              :ratio="16 / 5"
              :minWidth="1280"
              :minHeight="400"
              @setImage="setImageBgMobile"
            >
              <base-button design="four">
                <i class="far" style="color: #ffbf00"></i>
                {{ setLabel('background_mobile') }}
              </base-button>
            </upload-image>
            <!--  -->
            <!-- <base-button
              :text="StringLanguage.imageDatabase"
              design="four"
              @click="imgDB.drawer.open = !imgDB.drawer.open"
            /> -->
            <base-button
              :text="StringLanguage.delete"
              design="four"
              @click="images.background_mobile = ''"
              class="ml_15"
            />
            <input type="hidden" v-model="images.background_mobile" value="" />

            <!-- <div v-if="images.background_mobile" id="btn_background_control" class="mt_15 d-flex">
                        <base-button :text="StringLanguage.view" design="four"  id="btn_background_view" @click="() => openPreview(images.background_mobile)"  class="mr_15"/>
                        <base-button :text="StringLanguage.delete" design="four"  @click="images.background_mobile = ''"/>
                    </div> -->
          </div>
        </div>
        <div>
          <img
            v-if="!isMobile && images.background_mobile"
            :src="getPreviewUrl(images.background_mobile)"
            style="height: auto; width: 100px"
          />
        </div>
      </base-box>
      <!-- fim capa -->

      <!-- Ícone -->
      <base-box class="d-flex flex justify-between mb_20">
        <div class="w-100">
          <div v-if="isMobile && images.favicon">
            <div class="box-icons d-flex justify-between">
              <div class="icon-type">
                <div class="icon-favicon">
                  <img
                    v-if="images.favicon"
                    :src="getPreviewUrl(images.favicon)"
                    class="img-icon rounded"
                  />
                </div>
              </div>
            </div>
          </div>

          <input
            type="file"
            id="icon"
            name="icon"
            class="hidden"
            data-upload="{'max_height':'1024','extension':'jpg, jpeg, png, gif'}"
          />
          <base-label :text="StringLanguage.imageFavicon" />
          <p class="image-limit">{{ StringLanguage.imageIconLimit }}.</p>

          <div id="btn_icon" class="mt_20 d-flex">
            <upload-image
              :environment="environment"
              :minWidth="200"
              :minHeight="200"
              @setImage="setImageFavicon"
            >
              <base-button :text="setLabel('icon')" design="four" />
            </upload-image>
            <base-button
              v-if="!isMobile && images.favicon"
              :class="{ hidden: !images.favicon }"
              class="ml_15"
              :text="StringLanguage.delete"
              design="four"
              @click="images.favicon = ''"
            />
            <input type="hidden" v-model="images.favicon" value="" />
          </div>
        </div>
        <div v-if="!isMobile && images.favicon">
          <div class="box-icons d-flex justify-between">
            <div class="icon-type">
              <div class="icon-favicon">
                <img
                  v-if="images.favicon"
                  :src="getPreviewUrl(images.favicon)"
                  class="img-icon rounded"
                />
              </div>
            </div>
          </div>
        </div>
      </base-box>

      <!-- OCB
      <base-box class="d-flex flex justify-between mb_20">
        <div>
          <div v-if="isMobile && images.icon">
            <div class="box-icons d-flex justify-between">
              <div class="icon-type">
                <div
                  class="icon-app-circle"
                  :style="`background: ${images.color}`"
                >
                  <img
                    v-if="images.icon"
                    :src="getPreviewUrl(images.icon)"
                    class="img-icon"
                  />
                </div>
                <p class="icon-label">Aplicativo em icones redondos</p>
              </div>
              <div class="icon-type">
                <div
                  class="icon-app-square"
                  :style="`background: ${images.color}`"
                >
                  <img
                    v-if="images.icon"
                    :src="getPreviewUrl(images.icon)"
                    class="img-icon"
                  />
                </div>
                <p class="icon-label">Aplicativo em icones quadrados</p>
              </div>
            </div>
          </div>

          <input
            type="file"
            id="icon"
            name="icon"
            class="hidden"
            data-upload="{'max_height':'1024','extension':'jpg, jpeg, png, gif'}"
          />
          <base-label :text="StringLanguage.imageIcon" />
          <p class="image-limit">{{ StringLanguage.imageIconLimit }}.</p>

          <div id="btn_icon" class="mt_20 d-flex">
            <upload-image
              :environment="environment"
              :minWidth="1024"
              :minHeight="1024"
              @setImage="setImageIcon"
            >
              <base-button :text="setLabel('icon')" design="four" />
            </upload-image>
            <base-button
              :class="{ hidden: !images.icon }"
              class="ml_15"
              :text="StringLanguage.delete"
              design="four"
              @click="images.icon = ''"
            />
            <input type="hidden" v-model="images.icon" value="" />
          </div>

          <div class="mt_45">
            <base-label :text="StringLanguage.imageBackground" />
            <p class="image-limit">{{ StringLanguage.imageBackgroundInfo }}.</p>

            <div class="mt_20 d-flex align-center">
              <base-input
                :label="images.color"
                placeholder="Ex: #000000"
                :value="images.color"
                class="mb_0 input-hex"
                @keyup="changeColor"
                @keyup.enter="changeColor"
                max="7"
              />
              <input
                type="color"
                class="input-color mt_10 ml_15"
                v-model="images.color"
              />
            </div>

            <base-checkbox
              label="Aproximar imagem"
              class="mt_20"
              v-model="images.iconZoom"
              :checked="images.iconZoom"
            />
          </div>
        </div>
        <div v-if="!isMobile && images.icon">
          <div class="box-icons d-flex justify-between">
            <div class="icon-type">
              <div
                class="icon-app-circle"
                :style="`background: ${images.color}`"
              >
                <img
                  v-if="images.icon"
                  :src="getPreviewUrl(images.icon)"
                  class="img-icon"
                  :style="images.iconZoom ? 'width: 100%; height: 100%;' : ''"
                />
              </div>
              <p class="icon-label">Aplicativo em icones redondos</p>
            </div>
            <div class="icon-type">
              <div
                class="icon-app-square"
                :style="`background: ${images.color}`"
              >
                <img
                  v-if="images.icon"
                  :src="getPreviewUrl(images.icon)"
                  class="img-icon"
                  :style="images.iconZoom ? 'width: 100%; height: 100%;' : ''"
                />
              </div>
              <p class="icon-label">Aplicativo em icones quadrados</p>
            </div>
          </div>
        </div>
      </base-box>
      FIM OCB -->
      <!-- fim Ícone -->

      <!-- <div class="d-flex justify-end w-100">
            <base-button :text="StringLanguage.save" @click="save"/>
        </div> -->

      <base-drawer
        :open="previewImage.open"
        :title="StringLanguage.previewImage"
      >
        <img :src="previewImage.selectedImage" class="px_15 w-100" />
      </base-drawer>

      <base-drawer
        :open="imgDB.drawer.open"
        :close="imgDB.drawer.close"
        :title="StringLanguage.imageDatabase"
      >
        <base-card>
          <base-select title="Tipo do restaurante" v-model="filteredCategory">
            <option
              v-for="(categoryImg, iCategoryImg) in imgDB.base"
              :key="iCategoryImg"
              :value="`${iCategoryImg}`"
            >
              {{ categoryImg.category_name }}
            </option>
          </base-select>

          <div class="row mt_20">
            <div
              v-for="(sImg, iImg) in imgDB.base[filteredCategory].images"
              :key="iImg"
              class="col-lg-6 col-xs-12"
              @click.prevent="setImageBgMobile(sImg)"
            >
              <div class="box-image">
                <img :src="sImg" class="img-fluid image-base" />
                <div class="image-fade"></div>
                <p
                  v-if="sImg == images.background_mobile"
                  class="image-selected"
                >
                  <i class="fal fa-check mr_5"></i>Selecionado
                </p>
              </div>
            </div>
          </div>
        </base-card>

        <!-- <template v-slot:footer>
            <div class="d-flex justify-end w-100">
                <base-button :text="StringLanguage.applyCover" @click="save"/>
            </div>
            </template> -->
      </base-drawer>
      <div class="d-flex justify-end w-100" v-if="hasChanges()">
        <base-button design="save" @click="onSave" />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Images from '@/plugins/core/schema/configurations/BasicInfo/Images';
import StoreAPI from '@/api/store';
import UploadImage from '@/containers/UploadImage';
import { getXAPIEnv } from '@/plugins/account';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseLabel from '@/components/Label';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseSelect from '@/components/Select';
import BaseCheckbox from '@/components/Checkbox';

import imagesDB from '@/assets/json/imagesdb.json';

export default {
  data() {
    return {
      loadingData: false,
      images: new Images(),
      originalData: null,
      urlImage: `${process.env.VUE_APP_IMAGES}/${getXAPIEnv()}`,
      environment: getXAPIEnv(),
      imgDB: {
        base: imagesDB,
        drawer: {
          open: false,
          close: true,
        },
      },
      imgBaseDrawer: false,
      previewImage: {
        open: false,
        close: true,
        selectedImage: '',
      },
      filteredCategory: 0,
    };
  },
  components: {
    UploadImage,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseLabel,
    BaseDrawer,
    BaseCard,
    BaseSelect,
    BaseCheckbox,
  },
  created() {
    const self = this;
    this.loadingData = true;
    StoreAPI.storeGetConfiguration('images')
      .then((response) => {
        self.set(response);
      })
      .catch((err) => {
        console.log(err);
        alert(StringLanguage.loadError);
      })
      .finally(() => {
        this.loadingData = false;
      });
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges()) {
      confirm(`${StringLanguage.confirmComplement}`, (res) => {
        if (res) next();
      });
    } else {
      next();
    }
  },
  methods: {
    hasChanges() {
      return JSON.stringify(this.originalData) !== JSON.stringify(this.images);
    },
    onSave() {
      if (this.hasChanges()) {
        if (this.$route.params.done && !this.images.logo) {
          alert(StringLanguage.confirmInfoWithoutLeaveRoute);
        } else {
          this.save();
        }
      } else {
        alert(StringLanguage.noChanges);
      }
    },
    changeColor(e) {
      const { value } = e.target;

      if (value.length >= 7) {
        if (!/^#([a-fA-F0-9]{6})$/.test(value)) return (e.target.value = '');
        this.images.color = value;
        this.$set(this.images);
        this.$forceUpdate();
      }
    },
    set(response) {
      if (response.getErrors([]).length > 0) {
        return false;
      }
      if (response.getData({}).images || false) {
        const { images } = response.getData(new Images());
        Vue.set(
          this,
          'images',
          new Images(
            images.logo,
            images.icon,
            images.favicon,
            images.background,
            images.background_mobile,
            images.banner,
            images.banner_title,
            images.color,
            images.iconZoom
          )
        );
        Vue.set(
          this,
          'originalData',
          new Images(
            images.logo,
            images.icon,
            images.favicon,
            images.background,
            images.background_mobile,
            images.banner,
            images.banner_title,
            images.color,
            images.iconZoom
          )
        );
      } else {
        Vue.set(this, 'images', new Images());
        Vue.set(this, 'originalData', new Images());
      }
    },
    save() {
      const self = this;
      this.loadingData = true;
      StoreAPI.storeConfiguration({
        images: self.images,
      })
        .then((response) => {
          if (response.getErrors([]).length > 0) {
            alert(StringLanguage.saveError);
          } else {
            this.$store.dispatch('store/getConfigurations');
            alert(StringLanguage.saveSuccess);
          }

          self.set(response);
        })
        .catch((err) => {
          alert(StringLanguage.saveError);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    setImageLogo(fileName) {
      this.images.logo = fileName;
      this.$set(this.images);
    },
    setImageIcon(fileName) {
      this.images.icon = fileName;
      this.$set(this.images);
    },
    setImageFavicon(fileName) {
      this.images.favicon = fileName;
      this.$set(this.images);
    },
    setImageBg(fileName) {
      this.images.background = fileName;
      this.$set(this.images);
    },
    setImageBgMobile(fileName) {
      this.images.background_mobile = fileName;
      this.$set(this.images);
    },
    setImageBanner(fileName) {
      this.images.banner = fileName;
      this.$set(this.images);
    },
    setLabel(parameter) {
      return this.images[parameter]
        ? StringLanguage.changeImage
        : StringLanguage.loadImage;
    },
    openPreview(image) {
      this.previewImage.open = !this.previewImage.open;
      try {
        const url = new URL(image);
        this.previewImage.selectedImage = image;
      } catch (e) {
        this.previewImage.selectedImage = `${this.urlImage}/${image}`;
      }
    },

    getPreviewUrl(image) {
      try {
        const url = new URL(image);
        return image;
      } catch (e) {
        return `${this.urlImage}/${image}`;
      }
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
};
</script>

<style scoped>
.rounded {
  border-radius: 50%;
  overflow: hidden;
  margin: auto;
}
.image-limit {
  font-size: 1.2em;
  color: #aaaaab80;
}
.box-image {
  position: relative;
  margin-bottom: 15px;
  border-radius: 5px;
  overflow: hidden;
}
.image-fade {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00000080;
}
.image-selected {
  background-color: #0dc59df0;
  padding: 5px;
  border-radius: 5px;
  color: white;
  position: absolute;
  top: 5px;
  right: 5px;
  line-height: 15px;
}

.input-color {
  height: 45px;
  border-radius: 7px;
  width: 45px;
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  padding: 0;
}

.input-color::-webkit-color-swatch-wrapper {
  padding: 0;
}

.input-color::-webkit-color-swatch {
  border: none;
  border-radius: 5px;
}

.input-color::-moz-color-swatch {
  border: none;
  border-radius: 5px;
}

.input-hex {
  max-width: 140px;
}

.box-icons {
  height: 100%;
  align-items: center;
}

.img-icon {
  height: auto;
  width: 92px;
}

.icon-favicon {
  background: #fff;
  display: flex;
  border-radius: 50%;
  overflow: hidden;
}

.icon-type {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 45px;
}

.icon-type p {
  margin-top: 10px;
  max-width: 100px;
  text-align: center;
  color: var(--label-primary);
  font-size: 1.2em;
  line-height: 18px;
}

.icon-app-circle {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  overflow: hidden;
}

.icon-app-circle img {
  width: 53px;
  height: 53px;
}

.icon-app-square {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  overflow: hidden;
}

.icon-app-square img {
  width: 72px;
  height: 72px;
}

/* MOBILE */
@media (max-width: 991px) {
  .box-icons {
    flex-direction: column;
  }
  .icon-type {
    margin: 0 0 30px 0;
  }
  .cards {
    display: block;
  }
  .icon-favicon {
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
